import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiGet, apiPost } from 'app/shared-components/util/restAPI';

const API_NAME = 'CoreAPI3';
const PUBLIC_API_NAME = 'PublicAPI3';

export const fetchPublicBookingInfo = createAsyncThunk(
  'booking/fetchPublicInfo',
  async (userId) => {
    return await apiGet(PUBLIC_API_NAME, `/x3/clientsession/public/booking?userId=${userId}`, {});
  }
);

export const fetchAuthBookingInfo = createAsyncThunk(
  'booking/fetchAuthInfo',
  async (userId) => {
    return await apiGet(API_NAME, `/x3/clientsession/booking?userId=${userId}`, {});
  }
);

export const createPublicBooking = createAsyncThunk(
  'booking/createPublic',
  async (bookingData, { rejectWithValue }) => {
    try {
      return await apiPost(PUBLIC_API_NAME, '/x3/clientsession/public/booking', { body: bookingData });
    } catch (error) {
      return rejectWithValue({ status: error.code, message: error.message });
    }
  }
);

export const createAuthBooking = createAsyncThunk(
  'booking/createAuth',
  async (bookingData, { rejectWithValue }) => {
    try {
      return await apiPost(API_NAME, '/x3/clientsession/booking', { body: bookingData });
    } catch (error) {
      return rejectWithValue({ status: error.code, message: error.message });
    }
  }
);

const bookingSlice = createSlice({
  name: 'booking',
  initialState: {
    bookingInfo: null,
    loading: false,
    error: null,
    bookingResult: null
  },
  reducers: {
    clearBookingResult: (state) => {
      state.bookingResult = null;
      state.error = null;
    },
    clearBookingInfo: (state) => {
      state.bookingInfo = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPublicBookingInfo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPublicBookingInfo.fulfilled, (state, action) => {
        state.bookingInfo = action.payload;
        state.loading = false;
      })
      .addCase(fetchPublicBookingInfo.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      })
      .addCase(fetchAuthBookingInfo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAuthBookingInfo.fulfilled, (state, action) => {
        state.bookingInfo = action.payload;
        state.loading = false;
      })
      .addCase(fetchAuthBookingInfo.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      })
      .addCase(createPublicBooking.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createPublicBooking.fulfilled, (state, action) => {
        state.bookingResult = action.payload;
        state.loading = false;
      })
      .addCase(createPublicBooking.rejected, (state, action) => {
        state.error = action.payload || action.error.message;
        state.loading = false;
      })
      .addCase(createAuthBooking.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createAuthBooking.fulfilled, (state, action) => {
        state.bookingResult = action.payload;
        state.loading = false;
      })
      .addCase(createAuthBooking.rejected, (state, action) => {
        state.error = action.payload || action.error.message;
        state.loading = false;
      });
  }
});

export const { clearBookingResult, clearBookingInfo } = bookingSlice.actions;
export const selectBookingInfo = (state) => state.booking.bookingInfo;
export const selectBookingResult = (state) => state.booking.bookingResult;
export const selectBookingLoading = (state) => state.booking.loading;
export const selectBookingError = (state) => state.booking.error;
export default bookingSlice.reducer;
